var _circle, _path, _path2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg11 = function Svg11(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    fill: "url(#paint0_linear_692_423019)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7742 21H7.59417C5.72945 20.85 2 19.38 2 14.7C2 11.55 5.0625 9.3 7.25 9.3C7.25 7.95 9 3 14.25 3C17.75 3 19.5 5.25 20.5302 6.6C21.4335 6.15 23.875 6.15 25.1875 6.6C26.5 7.05 30 9.3 30 13.8C30 18.3 26.0625 21 22.7742 21Z",
    fill: "url(#paint1_linear_692_423019)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20161 25.795C9.73724 25.432 10.5598 24.9848 11.4346 25.0004C12.297 25.0157 12.9242 25.4603 13.3669 25.774C13.3862 25.7876 13.4051 25.801 13.4236 25.8141C13.8948 26.1468 14.1961 26.3364 14.6022 26.3479C15.0821 26.319 15.3268 26.1286 15.695 25.8252C15.7044 25.8175 15.7139 25.8096 15.7235 25.8017C16.1247 25.4706 16.6825 25.0103 17.6308 25.0003L17.655 25.0001L17.6792 25.0014C18.562 25.0507 19.1153 25.4906 19.5093 25.8038C19.526 25.8171 19.5425 25.8302 19.5587 25.8431C19.943 26.1474 20.1977 26.3296 20.6605 26.3489C20.9733 26.3614 21.4453 26.1539 21.9374 25.8207C22.1623 25.6684 22.3577 25.5132 22.4971 25.3958C22.5663 25.3374 22.6206 25.2893 22.6566 25.2568C22.6745 25.2405 22.6878 25.2283 22.6961 25.2206C22.7002 25.2168 22.703 25.2141 22.7045 25.2127L22.7054 25.2119C23.0238 24.9077 23.5142 24.9349 23.8007 25.2734C24.0874 25.6121 24.0617 26.134 23.7433 26.4389L23.7421 26.4401L23.7403 26.4417L23.7353 26.4465C23.7312 26.4504 23.7257 26.4555 23.7189 26.4619C23.7052 26.4746 23.6862 26.4922 23.6621 26.514C23.614 26.5576 23.5457 26.618 23.4607 26.6896C23.2915 26.8321 23.0519 27.0226 22.7707 27.2131C22.2506 27.5653 21.426 28.0317 20.6011 27.9983C19.6379 27.9583 19.0568 27.5034 18.632 27.1671C18.2281 26.8472 18.0081 26.679 17.6219 26.6513C17.2259 26.6615 17.0256 26.8167 16.6453 27.1301L16.6416 27.1332C16.2247 27.4767 15.6514 27.9492 14.6502 27.998L14.6279 27.9991L14.6055 27.9988C13.695 27.9873 13.0488 27.5308 12.5892 27.2061C12.5812 27.2005 12.5733 27.1949 12.5655 27.1894C12.0703 26.8397 11.7893 26.6576 11.4087 26.6508C11.003 26.6436 10.5026 26.8704 10.0355 27.1871C9.81603 27.3358 9.62994 27.4865 9.49903 27.5998C9.434 27.6561 9.38366 27.7023 9.35079 27.7332C9.33438 27.7486 9.32241 27.7602 9.31522 27.7671C9.31163 27.7706 9.3081 27.7741 9.3081 27.7741C8.99644 28.086 8.50547 28.0712 8.21166 27.7401C7.91752 27.4086 7.93169 26.8863 8.24331 26.5734L8.24461 26.5721L8.24643 26.5703L8.25158 26.5652C8.25568 26.5611 8.26111 26.5558 8.26783 26.5492C8.28127 26.5362 8.29988 26.5183 8.3233 26.4963C8.3701 26.4523 8.43643 26.3915 8.51939 26.3197C8.68448 26.1767 8.91973 25.9861 9.20161 25.795Z",
    fill: "#9BAFC2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_692_423019",
    x1: 3,
    y1: 2.5,
    x2: 15.375,
    y2: 14.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAE359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEB41C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_692_423019",
    x1: 6.91448,
    y1: 4.5068,
    x2: 24.7045,
    y2: 21.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCFE1"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg11, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/11.f36a8053.svg";
export { ForwardRef as ReactComponent };